import type { Template } from '@/hooks/useTemplates'
import type { VideoRatio } from '@/lib/constants'
import type { FrameImage, ApplyableSettings } from '@/types/generation'
import { localizeTextPrompt } from '@/lib/i18n-content'

/** 썸네일 URL에 캐시 버스팅 파라미터 추가 */
function withCacheBusting(url: string | null, updatedAt: string): string | null {
  if (!url) return null
  const timestamp = new Date(updatedAt).getTime()
  return `${url}?v=${timestamp}`
}

/**
 * Template에서 ApplyableSettings로 변환
 * 비디오 설정 (ratio, resolution, duration) 포함
 */
export function extractSettingsFromTemplate(template: Template): ApplyableSettings {
  const frameImages: FrameImage[] = template.frameImages.map((fi, idx) => ({
    id: `template-${template.id}-${idx}`,
    role: fi.role,
    s3Key: fi.s3Key,
    thumbnailS3Key: fi.thumbnailS3Key,
    url: fi.thumbnailUrl,
    thumbnailUrl: fi.thumbnailUrl,
  }))

  return {
    // 현재 UI 언어의 번역 프롬프트로 채운다 (없으면 ko 원문 폴백). 파라미터 KEY 는 언어 무관 동일.
    prompt: localizeTextPrompt(template),
    ratio: template.ratio as VideoRatio,
    resolution: template.resolution,
    duration: template.duration,
    frameImages: frameImages.length > 0 ? frameImages : undefined,
    template: {
      id: template.id,
      name: template.name,
      description: template.description,
      nameI18n: template.nameI18n,
      descriptionI18n: template.descriptionI18n,
      thumbnailUrl: withCacheBusting(template.thumbnailUrl, template.updatedAt),
    },
  }
}

export function toTemplateThumbnailUrl(url: string | null, updatedAt: string): string | null {
  return withCacheBusting(url, updatedAt)
}
